import { CSSProperties, ChangeEventHandler, PropsWithChildren } from "react";

function InputField({
  initialValue,
  label,
  name,
  id,
  labelStyle,
  labelClassName,
  inputStyle,
  inputClassName,
  onChange,
}: PropsWithChildren<{
  initialValue?: string;
  label?: string;
  name?: string;
  id?: string;
  labelClassName?: string;
  inputClassName?: string;
  labelStyle?: CSSProperties;
  inputStyle?: CSSProperties;
  onChange: ChangeEventHandler<HTMLInputElement> | undefined;
}>) {
  return (
    <>
      <div style={{ ...labelStyle }} className={labelClassName}>
        <label htmlFor={id}>
          <span>{label}</span>
        </label>
      </div>
      <input
        onChange={onChange}
        id={id}
        defaultValue={initialValue}
        name={name}
        style={inputStyle}
        className={inputClassName}
      />
    </>
  );
}

export default InputField;
